// @flow
import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

import { ColorSchema, WhiteText, BlackText } from "../types/scss";

export const buttonStyles = theme => ({
  shineIcon: {
    color: ColorSchema("primary"),
    "&:hover": {
      color: ColorSchema("third"),
    },
  },
  linkBtn: {
    color: ColorSchema("secondary"),
    "&:hover" :{
      color: WhiteText,
      backgroundColor: ColorSchema("third"),
    },
  },
  shineBtn: {
    color: WhiteText,
    backgroundColor: ColorSchema("third"),
    "&:hover": {
      backgroundColor: ColorSchema("secondary"),
    },
  },
  primaryBtn: {
    backgroundColor: WhiteText,
    color: BlackText,
    width: "100%",
    fontSize: "15px",
    textTransform: "capitalize",
    border: "3px solid " + ColorSchema("secondary"),
    "&:hover": {
      backgroundColor: ColorSchema("third"),
      color: WhiteText,
    },
  },
});


// WEBPACK FOOTER //
// ./src/global/components/StyledButtons.js